function cartGetFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
}

const cartTrapFocusHandlers = {};

function cartTrapFocus(container, elementToFocus = container) {
    var elements = cartGetFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    cartRemoveTrapFocus();
  
    cartTrapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', cartTrapFocusHandlers.keydown);
    };
  
    cartTrapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', cartTrapFocusHandlers.keydown);
    };
  
    cartTrapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', cartTrapFocusHandlers.focusout);
    document.addEventListener('focusin', cartTrapFocusHandlers.focusin);
  
    elementToFocus.focus();
}

function cartRemoveTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', cartTrapFocusHandlers.focusin);
    document.removeEventListener('focusout', cartTrapFocusHandlers.focusout);
    document.removeEventListener('keydown', cartTrapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
}

class KiteCartItemQuantity extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}
customElements.define('kte-cart-item-quantity', KiteCartItemQuantity);


class KiteCartItemRemove extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const cartItems = this.closest('kte-cart-items') || this.closest('kte-cart-drawer-items');
            cartItems.updateQuantity(this.dataset.index, 0);
        });
    }
}
customElements.define('kte-cart-item-remove', KiteCartItemRemove);



class KiteCartItems extends HTMLElement {
    constructor() {
        super();

        this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
            .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

        this.debouncedOnChange = debounce((event) => {
            this.onChange(event);
        }, 300);

        this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
        this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }

    getSectionsToRender() {
        return [
            {
                id: 'main-cart-items',
                section: document.getElementById('main-cart-items').dataset.id,
                selector: '.js-contents',
            },
            {
                id: 'kte-cart-icon-bubble',
                section: 'kte-cart-icon-bubble',
                selector: '.shopify-section'
            },
            {
                id: 'cart-live-region-text',
                section: 'cart-live-region-text',
                selector: '.shopify-section'
            },
            {
                id: 'main-cart-footer',
                section: document.getElementById('main-cart-footer').dataset.id,
                selector: '.js-contents',
            }
        ];
    }

    fetchConfig(type = 'json') {
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
        };
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname
        });

        fetch('/cart/change', { ...this.fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.classList.toggle('is-empty', parsedState.item_count === 0);
                const cartDrawerWrapper = document.querySelector('kte-cart-drawer');
                const cartFooter = document.getElementById('main-cart-footer');

                if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
                if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

                this.getSectionsToRender().forEach((section => {
                    const elementToReplace =
                        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    elementToReplace.innerHTML =
                        this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
                }));

                this.updateLiveRegions(line, parsedState.item_count);


                const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
                } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                    trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
                }
                this.disableLoading();
            }).catch(() => {
                this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                //const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                //errors.textContent = window.cartStrings.error;
                  console.error('=== CART UPDATE FAILED ===');
                    console.error('Error object:', window.cartStrings.error);
                    console.error('Error message:', window.cartStrings.error.message);
                    
                    this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
                    console.log('Error message from cartStrings:', window.cartStrings?.error);
                    this.disableLoading();
                this.disableLoading();
            });
    }

    updateLiveRegions(line, itemCount) {
        if (this.currentItemCount === itemCount) {
            const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
            const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

            lineItemError
                .querySelector('.cart-item__error-text')
                .innerHTML = window.cartStrings.quantityError.replace(
                    '[quantity]',
                    quantityElement.value
                );
        }

        this.currentItemCount = itemCount;
        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
            cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
    }

    disableLoading() {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.remove('cart__items--disabled');
    }
}
customElements.define('kte-cart-items', KiteCartItems);



class KiteCartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('.kte-cart-btn');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(cartLink)
        });
        cartLink.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => { this.classList.add('animate', 'active') });

        this.addEventListener('transitionend', () => {
            const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
            const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
            trapFocus(containerToTrapFocusOn, focusElement);
        }, { once: true });

        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    renderContents(parsedState) {
        this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            sectionElement.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));

        setTimeout(() => {
            this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
            this.open();
        });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: 'kte-cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'kte-cart-icon-bubble'
            }
        ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('kte-cart-drawer', KiteCartDrawer);



class KiteCartDrawerItems extends KiteCartItems {
    getSectionsToRender() {
        return [
            {
                id: 'CartDrawer',
                section: 'kte-cart-drawer',
                selector: '.drawer__inner'
            },
            {
                id: 'kte-cart-icon-bubble',
                section: 'kte-cart-icon-bubble',
                selector: '.shopify-section'
            }
        ];
    }
}
customElements.define('kte-cart-drawer-items', KiteCartDrawerItems);


if (!customElements.get('cart-note')) {
    customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();
  
        this.addEventListener('change', debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300))
      }
    });
}; 